import React, {useEffect} from "react";
import Aos from "aos";
import "./Banner.scss";

const Banner = ({children, bgr, img,}) => {
    // const { bgr, img, title, desc, apps } = props;
    useEffect(() => {
        Aos.init({duration: 1000});
    }, []);
    return (
        <div>
            <div className="d-none d-lg-block">
                <div className="banner-web" style={{
                    backgroundImage: `url(${bgr})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                }}>
                    <div className="btn-content" style={{zIndex: 1}}>
                        {children}
                    </div>
                    <div className="btn-image">
                        <div data-aos="fade-up-left">
                            <img src={img} alt={img} className="img-fluid"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-block d-lg-none">
                <div className="banner-mobile">
                    <div>
                        <div data-aos="fade-up-left">
                            <img src={img} alt={img} className="img-fluid"/>
                        </div>
                    </div>
                    <div className="mt-5">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
